import type { ReduxAction } from '../../types';

export interface ContactViewState {
  creatingNewNote: boolean;
  newReminderEditorOpen?: boolean;
}

const initialContactViewState = {
  creatingNewNote: false,
  newReminderEditorOpen: false,
};

export function contactViewReducer(
  state: ContactViewState = initialContactViewState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    // a contact can be selected either by viewing that contact's profile or by
    // highlighting the row of that contact in search/inbox/reminders/group detail view
    case 'SET_CREATING_NEW_NOTE_IN_CONTACT_VIEW':
      return {
        ...state,
        creatingNewNote: payload.creatingNewNote,
        newReminderEditorOpen: payload.creatingNewReminder,
      };

    case 'OPEN_NEW_REMINDER_EDITOR_IN_CONTACT_VIEW':
      return {
        ...state,
        newReminderEditorOpen: true,
      };

    case 'CLOSE_NEW_REMINDER_EDITOR_IN_CONTACT_VIEW':
      return {
        ...state,
        newReminderEditorOpen: false,
      };

    default:
      return state;
  }
}
